<template>
    <section class="base-header-sec base-header-laen  laen">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">

            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                    <h2 class="base-header__title mob d-block d-lg-none">
                        {{title}}
                    </h2>
                    <ul class="nav ">
                        <li class="nav-item">
                            <router-link class="nav-link" :to="'/arhslgl-' + slug">Садржај</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :to="'/arhslgl-' + slug + '-search'">Претрага</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/arhslgl-static', query: { page: 'help' ,code:staticPageSlug}}">
                                Помоћ
                            </router-link>
                            <!--                                <a class="nav-link" href="#">Помоћ</a>-->
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/arhslgl-static', query: { page: 'contact' ,code:staticPageSlug}}">
                                Контакт
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link "
                                         :to="{ path: '/arhslgl-static', query: { page: 'impresum' ,code:staticPageSlug}}">
                                Импресум
                            </router-link>
                        </li>
                    </ul>
                    <h1 class="base-header__title d-none d-lg-block">
                        {{title}}
                    </h1>
                </div>
            </div>
        </div>
<!--        <p style="color: #fff">{{slug}}</p>-->
    </section>
</template>

<script>
    export default {
        name: "ArhslglBaseHeaderSec",
        props: ['title', 'slug'],
        computed: {
            staticPageSlug() {
                let extCode;
                switch (this.slug) {
                    case 'sgarh':
                        extCode = 'SGARHSTARO';
                        break;
                    case 'pgarh':
                        extCode = 'PGARHSTARO';
                        break;
                    case 'slarh':
                        extCode = 'SLARHSTARO';
                        break;
                    case 'muarh':
                        extCode = 'MUARHSTARO';
                        break;
                    default:
                    // code block
                }
                return extCode
                // SGARHSTARO
                // PGARHSTARO
                // SLARHSTARO
                // MUARHSTARO

            }
        }
    }
</script>

<style scoped>

</style>
